export default "__VITE_ASSET__C4U4SYdS__"